import { render, staticRenderFns } from "./custom_pay.vue?vue&type=template&id=2446c251&scoped=true"
import script from "./custom_pay.vue?vue&type=script&lang=js"
export * from "./custom_pay.vue?vue&type=script&lang=js"
import style0 from "./custom_pay.vue?vue&type=style&index=0&id=2446c251&prod&scoped=true&lang=scss"
import style1 from "./custom_pay.vue?vue&type=style&index=1&id=2446c251&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2446c251",
  null
  
)

export default component.exports